import { createSelector } from 'reselect';
import { RootState } from '@store';
import { isVariantDiscounted } from './pricing';

const getPending = (state: RootState) => state.shop.pending;

const getProducts = (state: RootState) => state.shop.data;

const getError = (state: RootState) => state.shop.error;

const getAddPending = (state: RootState) => state.shop.addPending;
const getAddError = (state: RootState) => state.shop.addError;

const getRemovePending = (state: RootState) => state.shop.removePending;
const getRemoveError = (state: RootState) => state.shop.removeError;

export const getUpsellsSelector = createSelector(getProducts, (products) => products);

// True when at least one upsell variant is genuinely marked down. The test for
// "genuinely" lives in `isVariantDiscounted`, which the product card uses too, so
// the page and the chrome around it cannot disagree about whether a sale is on.
//
// Gates every piece of campaign UI: the sidebar and mobile nav badges, the
// campaign banner on both breakpoints, and the product card's `-20%` circle plus
// the struck-through originals on the card and in the confirm modal. When a
// campaign ends and the markdowns drop out of the feed, all of it disappears on
// its own rather than waiting on someone to delete `hasDiscountIcon` from
// `navi.ts`.
//
// False while the upsells are still in flight, since `data` starts empty. That is
// the better default of the two: revealing the badge once a discount is confirmed
// looks deliberate, whereas showing it immediately and yanking it a moment later
// reads as a glitch.
//
export const getHasUpsellDiscountSelector = createSelector(getProducts, (products) =>
  (products ?? []).some((product) => product.variants?.some(isVariantDiscounted)),
);

export const getUpsellsPendingSelector = createSelector(getPending, (pending) => pending);

export const getUpsellsErrorSelector = createSelector(getError, (error) => error);

export const getAddUpsellPendingSelector = createSelector(getAddPending, (pending) => pending);
export const getAddUpsellErrorSelector = createSelector(getAddError, (error) => error);

export const getRemoveUpsellPendingSelector = createSelector(
  getRemovePending,
  (pending) => pending,
);
export const getRemoveUpsellErrorSelector = createSelector(getRemoveError, (error) => error);
